import { Work } from '../types'

const statusLabelMap: Record<Work['status'], string> = {
  scheduled: 'Scheduled',
  rejected: 'Rejected',
  started: 'Started',
  bailed: 'Bailed',
  completed: 'Completed',
  approved: 'Approved',
  paid: 'Paid',
  removed: 'Removed',
  admin_review: 'Admin Review',
  employer_review: 'Employer Review',
  employer_approved: 'Employer Approved',
  employer_cancelled: 'Employer Cancelled',
  worker_declined_req: 'Worker Declined Request',
  system_declined: 'System Declined',
}

export const getStatusLabel = (status: Work['status']) => {
  return statusLabelMap[status] || status.replace('_', ' ')
}
